module.exports = __webpack_public_path__ + "static/media/doc.e4be7d61.svg";